import React, { useState, useEffect } from 'react';
import { useCart } from "react-use-cart";
import axios from 'axios';

import ParticlesBG from "../Shared/ParticlesBG";

export default function ProductTest() {
  const [responseData, setResponseData] = useState(null);
  const { addItem } = useCart();

  const fetchData = async () => {
    try {
      const response = await axios.get('http://localhost:5000/api/addons');
      setResponseData(response.data.addons);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <ParticlesBG />
      <div className="container">
        {responseData && responseData.filter(p => p.product_name === "Services" && p.addon_code != "SETUP-ADDON").map((p) => (
          <div key={p.id} className="is-flex has-text-white">
            {p.name} - {p.price_brackets[0].price}
            <a className="button" onClick={() => addItem({...p, id: p.addon_id, price: p.price_brackets[0].price})}>
              Add to cart
            </a>
          </div>
        ))}
      </div>
    </>
  )
}
